import React from 'react';

// Components
import Orders from 'components/Orders';

const OrdersAbacaPage = () => <Orders isAdmin={true} />;

export default OrdersAbacaPage;
